/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  connect
} from 'react-redux';
import { Form, FormElement } from '@progress/kendo-react-form';
import { Button, ButtonGroup, Container } from 'react-bootstrap';
import { physicianEndpoints } from 'endpoints/physician';
import { mmurApi } from 'utility/axios_config';
import { lookupEndPoints } from 'endpoints/lookup';
import { PhysicianType } from 'utility/enumerations';
import moment from 'moment';
import StatusCheck from './status_check';
import RegistrationCheck from './registration_check';
import { MQAResultModal } from './mqa_result_modal';
// @ts-ignore
import styles from '../physician.module.scss';
import { MqaCheckValidatorFactory } from './mqa_check_validator';

function MqaCheck(props) {
  const [showRegistrationCheck, updateShowRegistrationCheck] = useState(true);
  const [showStatusCheck, updateShowStatusCheck] = useState(false);
  const [professions, setProfessions] = useState([]);
  const [showMqaResultModal, setShowMqaResultModal] = useState(false);
  const [mqaResultData, setMqaResultData] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [modalSubtitle, setModalSubitle] = useState('');

  function toggleTabs(tab) {
    if (tab === 'registration') {
      updateShowRegistrationCheck(true);
      updateShowStatusCheck(false);
    }
    if (tab === 'status') {
      updateShowRegistrationCheck(false);
      updateShowStatusCheck(true);
    }
  }

  const fetchData = () => {
    const url = lookupEndPoints.getProfessions();

    mmurApi.get(url).then(({ data: { data } }) => {
      setProfessions(data
        .sort((a, b) => ((a.description > b.description) ? 1 : -1))
        .map((p) => ({ id: p.code, name: `${p.code} - ${p.description} ${p.type === 'Reviewer' ? `(${p.type})` : ''}` })));
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (options) => {
    const params = { ...options, profession: options.profession.id };

    const url = showRegistrationCheck ? physicianEndpoints.checkMqaRegistration(params)
      : physicianEndpoints.checkMqaStatus(params);

    const title = `MQA - Physician ${showRegistrationCheck ? 'Self Registration' : 'Status Check'} Results`;

    const subTitle = showRegistrationCheck
      ? `Results of checking: \
    Profession-${options.profession.name}, \
    License #-${params.licenseNumber}, \
    First Name-${params.firstName}, \
    Last Name-${params.lastName}, \
    DOB-${moment(params.dob).format('MM/DD/YYYY')}, \
    Last 4 SSN-${params.lastFourSSN} \
    as of ${moment().format('MM/DD/YYYY hh:mm A')}`

      : `Results of checking: \
    Profession-${options.profession.name}, \
    License #-${params.licenseNumber} \
    as of ${moment().format('MM/DD/YYYY hh:mm A')}`;

    setModalTitle(title);
    setModalSubitle(subTitle);

    mmurApi.get(url).then(({ data: { data } }) => {
      // eslint-disable-next-line max-len
      setMqaResultData(JSON.stringify(data.mqaJsonResponse, null, 2));
      setShowMqaResultModal(true);
    });
  };

  return (
    <Container className="text-center">
      <div>
        <h3>MQA Tools - Physician Self Registration and Status Check</h3>
        <h6>Select Endpoint - MQA Search</h6>
        <ButtonGroup>
          <Button className={styles.mqaCheckButton} active={showRegistrationCheck} onClick={() => toggleTabs('registration')}>Physician Self Registration Check</Button>
          <Button className={styles.mqaCheckButton} active={showStatusCheck} onClick={() => toggleTabs('status')}>Physician Status Check</Button>
        </ButtonGroup>
      </div>
      <div>
        <Form
          initialValues={{
            physicianType: PhysicianType.Physician
          }}
          onSubmit={handleSubmit}
          validator={MqaCheckValidatorFactory(showRegistrationCheck)}
          render={(formRenderProps) => (
            <FormElement>
              {showRegistrationCheck
              && (
              <RegistrationCheck
                formRenderProps={formRenderProps}
                categoryClientContent={props.categoryClientcontent}
                professions={professions}
              />
              )}
              {showStatusCheck && (
              <StatusCheck
                formRenderProps={formRenderProps}
                categoryClientContent={props.categoryClientcontent}
                professions={professions}
              />
              )}
              <div className={styles.mqaToolButtons}>
                <ButtonGroup>
                  <Button className={styles.mqaToolButton} type="submit" disabled={!formRenderProps.allowSubmit || !formRenderProps.valid} variant="primary">
                    Submit
                  </Button>
                </ButtonGroup>
              </div>
            </FormElement>
          )}
        />
        <MQAResultModal
          show={showMqaResultModal}
          heading={modalTitle}
          subTitle={modalSubtitle}
          data={mqaResultData}
          buttontext="Close"
          size="xl"
          onHide={() => setShowMqaResultModal(false)}
          centered
          static="static"
          animation={false}
        />
      </div>
    </Container>
  );
}

function mapStateToProps(state) {
  return {
    categoryClientContent: state.content.categoryClientContent,
  };
}
export default connect(mapStateToProps)(MqaCheck);
